import CategoryViewItem from "component/categories-viewer/CategoryViewItem";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { capitalize } from "util/lodash/capitalize";
import { unCamelCase } from "util/lodash/unCamelCase";
import CategorySection from "../../../component/design-system/category-selection/CategorySection";
import styles from "../../site-structure/style-component.module.scss";
import SafeLink from "../SafeLink";

function CategoryItem(props: any) {
  const { url, linkDetails } = props;
  const label = linkDetails?.title || capitalize(unCamelCase(url.substring(1))).replace("-", " ");
  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  return (
    <div className={styles.style_model_item}>
      <HideIf show={selectedVehicle}>
        <CategoryViewItem url={url}>
          <a className="item">
            <span>{label}</span>
          </a>
        </CategoryViewItem>
      </HideIf>
      <HideIf show={!selectedVehicle}>
        <SafeLink href={url} className="item">
          <span>{label}</span>
        </SafeLink>
      </HideIf>

    </div>
  );
}

function RelatedCategories(props: any) {
  const { relatedCategories } = props;
  const { t } = useTranslation("category");
  return (
    <div id="related-categories" className="section">

      <CategorySection {...{
        categoryUrls: relatedCategories,
        maxRows: 3,
        title: t("Related Categories"),
        listStyle: {
          background: "#F5F5F5",
        },
      }}
      >

        <CategoryItem />
      </CategorySection>
    </div>
  );
}

export default RelatedCategories;
